var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBathtub(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4393 9.93934C11.7206 9.65804 12.1022 9.5 12.5 9.5C12.8978 9.5 13.2794 9.65804 13.5607 9.93934C13.842 10.2206 14 10.6022 14 11C13.4477 11 13 11.4477 13 12C13 12.5523 13.4477 13 14 13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11C15 10.337 14.7366 9.70107 14.2678 9.23223C13.7989 8.76339 13.163 8.5 12.5 8.5C11.837 8.5 11.2011 8.76339 10.7322 9.23223C10.2634 9.70107 10 10.337 10 11V15C9.44772 15 9 15.4477 9 16V19C9 20.6569 10.3431 22 12 22C12 22.5523 12.4477 23 13 23C13.5523 23 14 22.5523 14 22H18C18 22.5523 18.4477 23 19 23C19.5523 23 20 22.5523 20 22C21.6569 22 23 20.6569 23 19V16C23 15.4477 22.5523 15 22 15H11V11C11 10.6022 11.158 10.2206 11.4393 9.93934ZM10 17V19C10 20.1046 10.8954 21 12 21H20C21.1046 21 22 20.1046 22 19V17H10Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathtub);
export default __webpack_public_path__ + "static/media/bathtub.0d0fa8a44527e19c231801da286425cf.svg";
export { ForwardRef as ReactComponent };